import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from 'redux';

import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/styles";
import { Formik, useFormik, Field, Form, useFormikContext } from "formik";
import { createTheme } from "@material-ui/core";
import { GREENERGENIC_CONFIG } from "config";

import {
  Routes,
  Route,
  useSearchParams,
  BrowserRouter
} from "react-router-dom"

import {
  MAX_LENGTH,
  ev_model_list,
  simu_speed_list,
  simu_algorithm_list
} from "common/constants";


import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Grid,
  Typography,
  TextField,
  Button,
  Collapse,
  Divider
} from '@mui/material';

import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';


import firebase from '../../Firebase';
import { getDatabase, ref, set, update, onValue, get, child } from 'firebase/database';



import {
  updateSimuSetting,
  updateMakeRandomEVData,
  updateChgrCnt
} from "actions/settings";



const QRCodeInput = (props) => {
  const { className, history, simuSettings, updateMakeRandomEVData, ...rest } = props;

  const [queryParameters] = useSearchParams();

  const database = getDatabase();
  const dbRef = ref(database);

  const selector_ev_data = useSelector((state) => state.simuSettings.random_ev_data);

  const classes = useStyles();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      cs: queryParameters.get("cs") ?? '',
      lc: queryParameters.get("lc") ?? '',
      evse: queryParameters.get("evse") ?? '',
      timein: moment().format('YY/MM/DD HH:mm'),
      timetoleave: moment().add(3, 'hour').format('YY/MM/DD HH:mm'),
      currentRange: 100,
      desiredRange: 400,
      vehiclemodel: queryParameters.get("model") ?? '',
    },
  });



  const doCreate = (event, values) => {
    event.preventDefault();

    var prev_ev_data = [];

    if (selector_ev_data.length > 0){
      prev_ev_data = [...selector_ev_data];
    }

    //other 브라우저에서 열면, 공유되지 않는다.
    //공유는 오직 동일한 session내 에서만 된다.
    //--> firebase realtime db로 변경

    var count = 0;
    get( ref(database, 'simu/params/') ).then( (snapshot) => {
      if (snapshot.exists()){
        count = Object.keys(snapshot.val()).length;
        console.log('count: ', count);
      }else{
        console.log('No data in db');
      }

    });


    //note: 동일한 chgr_id 데이터가 있는지 확인
    //있으면 error, 없다면 등록
    get( child(dbRef, 'simu/params') ).then( (snapshot) => {

      var duplicated = false;
      var count = 0;

      snapshot.forEach(function (childSnapshot) {
        count += 1;

        if (childSnapshot.val().chgr_id == String(values.evse).padStart(2, '0')){
          alert('Alread registered EVSE');
          duplicated = true;
        }
      });


      if (!duplicated) {

        var new_obj = {
          idx: count,
          chgr_id: String(values.evse).padStart(2, '0'),
          on_time: values.timein,
          off_time: values.timetoleave,
          current_avail_dis: values.currentRange,
          desired_driving_dis: values.desiredRange,
          ev_model: values.vehiclemodel,
          profile:0,
          isNew: false,
          isActive: false
        };

        set( ref(database , 'simu/params/'+count), new_obj );
        // set( ref(database , 'simu/params/'+count), {
        //   idx: count,
        //   chgr_id: String(values.evse).padStart(2, '0'),
        //   on_time: values.timein,
        //   off_time: values.timetoleave,
        //   current_avail_dis: values.currentRange,
        //   desired_driving_dis: values.desiredRange,
        //   ev_model: values.vehiclemodel,
        //   profile:0,
        //   isNew: false,
        //   isActive: false
        // });


        prev_ev_data.push(new_obj);
        props.updateMakeRandomEVData(prev_ev_data);
        props.updateChgrCnt(prev_ev_data.length);

        alert('Registered successfully');
      }
    });



    // prev_ev_data.push({
    //   idx: prev_ev_data.length,
    //   chgr_id: String(values.evse).padStart(2, '0'),
    //   on_time: values.timein,
    //   off_time: values.timetoleave,
    //   current_avail_dis: values.currentRange,
    //   desired_driving_dis: values.desiredRange,
    //   ev_model: values.vehiclemodel,
    //   profile:0,
    //   isNew: false,
    //   isActive: false
    // });


    // props.updateMakeRandomEVData(prev_ev_data);
    // props.updateChgrCnt(prev_ev_data.length);


  }

    // const doCancel = (event, values) => {
    //   formik.setFieldValue('cs', queryParameters.get("cs") ?? '');
    //   formik.setFieldValue('lc', queryParameters.get("lc") ?? '');
    //   formik.setFieldValue('evse', queryParameters.get("evse") ?? '');
    // }


  // useEffect(() => {
  //   console.log('selector_ev_data: ', selector_ev_data);
  // }, [selector_ev_data]);



  return (
    <div className={classes.root}>

      <Formik
        {...formik}
        enableReinitialize={false}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          isSubmitting,
          touched,
          values,
          setFieldValue
        }) => (


          <form>
            <Card
              raised={false}
              style={{
                alignItems: "flex-start",
                // padding:theme.spacing(1)
              }}
            >

              <CardHeader align="center"
                title={<Typography variant="h5">QRCode Input</Typography>}
                style={{
                  borderBottom: "thick double darkgray",
                  // marginBottom: "10px", // Adjust the margin as needed
                  // paddingTop: "0", // Set padding-top to 0
                  marginInline: "2em",
                  backgroundColor: "lightgray",
                  // paddingTop: "10px",
                  marginTop: "10px",
                }}
              />


              <CardContent >
                <Grid container item md={12} xs={12} spacing={1} direction="row" alignItems="center" style={{ marginBlock: "10px" }}>


                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(touched.cs && errors.cs)}
                      fullWidth
                      helperText={touched.cs && errors.cs}
                      label={`Charging Site`}
                      disabled={true}
                      name="cs"
                      onChange={handleChange}
                      value={values.cs}
                      variant="outlined"
                      inputProps={{ maxLength: MAX_LENGTH.MAX_CHARGING_SITE, readOnly: false, style: { textAlign: 'left' } }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(touched.lc && errors.lc)}
                      fullWidth
                      helperText={touched.lc && errors.lc}
                      label={`Local Controller`}
                      disabled={true}
                      name="lc"
                      onChange={handleChange}
                      value={values.lc}
                      variant="outlined"
                      inputProps={{ maxLength: MAX_LENGTH.MAX_LOCAL_CONTROLLER, readOnly: false, style: { textAlign: 'left' } }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>


                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(touched.evse && errors.evse)}
                      fullWidth
                      helperText={touched.evse && errors.evse}
                      label={`EVSE ID(Max:2)`}
                      name="evse"
                      disabled={true}
                      onChange={handleChange}
                      value={values.evse}
                      variant="outlined"
                      inputProps={{ maxLength: 2, readOnly: false, style: { textAlign: 'left' } }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Divider  style={{marginBlock:'10px', backgroundColor:"black"}}/>


                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(touched.timein && errors.timein)}
                      fullWidth
                      helperText={touched.timein && errors.timein}
                      label={`Time-in`}
                      name="timein"
                      onChange={handleChange}
                      value={values.timein}
                      variant="outlined"
                      inputProps={{ maxLength: MAX_LENGTH.MAX_DATETIME, readOnly: false, style: { textAlign: 'left' } }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(touched.timetoleave && errors.timetoleave)}
                      fullWidth
                      helperText={touched.timetoleave && errors.timetoleave}
                      label={`Time-to-leave`}
                      name="timetoleave"
                      onChange={handleChange}
                      value={values.timetoleave}
                      variant="outlined"
                      inputProps={{ maxLength: MAX_LENGTH.MAX_DATETIME, readOnly: false, style: { textAlign: 'left' } }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(touched.currentRange && errors.currentRange)}
                      fullWidth
                      helperText={touched.currentRange && errors.currentRange}
                      label={`Current Range[km]`}
                      name="currentRange"
                      onChange={handleChange}
                      value={values.currentRange}
                      variant="outlined"
                      inputProps={{ maxLength: 10, readOnly: false, style: { textAlign: 'right' } }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(touched.desiredRange && errors.desiredRange)}
                      fullWidth
                      helperText={touched.desiredRange && errors.desiredRange}
                      label={`Desired Range[km]`}
                      name="desiredRange"
                      onChange={handleChange}
                      value={values.desiredRange}
                      variant="outlined"
                      inputProps={{ maxLength: 10, readOnly: false, style: { textAlign: 'right' } }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(touched.vehiclemodel && errors.vehiclemodel)}
                      fullWidth
                      helperText={touched.vehiclemodel && errors.vehiclemodel}
                      label={`Vehicle model`}
                      name="vehiclemodel"
                      onChange={handleChange}
                      value={values.vehiclemodel}
                      variant="outlined"
                      inputProps={{ maxLength: 30, readOnly: false, style: { textAlign: 'left' } }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                </Grid>
              </CardContent>


              <CardActions className={classes.actions}>
                <Grid container item className={classes.action}
                  direction="row" alignItems="center" justifyContent="center">

                  <Button
                    variant="contained"
                    color="primary"
                    // type="submit"
                    size="large"
                    // disabled={isSubmitting}
                    // disabled={isReadyToStart == false}
                    className={classes.action}
                    onClick={(e) => doCreate(e, values)}
                  >
                    Create
                  </Button>

                  {/* <Button
                    variant="outlined"
                    size="large"
                    // onClick={handleBack}
                    onClick={(e) => doCancel(e, values)}
                    className={classes.action}
                  >
                    Cancel
                  </Button>
                */}
                </Grid>
              </CardActions>



            </Card>
          </form>

        )}
      </Formik>
    </div>

  )
}

QRCodeInput.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object,
};


const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    updateSimuSetting,
    updateMakeRandomEVData,
    updateChgrCnt,
  }, dispatch);
};


let mapStateToProps = (state) => {
  return { simuSettings: state.simuSettings }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps)
  (QRCodeInput);
// export default QRCodeInput;


const theme = createTheme({
  spacing: 4,
})

const useStyles = makeStyles(() => ({
  root: {
    padding: theme.spacing(1),
  },
  content: {
    marginTop: theme.spacing(1),
  },
  action: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    "& + &": {
      marginLeft: theme.spacing(1),
    },
  },

  queryField: {
    flexBasis: 220,
    marginRight: 20,
  },
  bulkAction: {
    marginLeft: theme.spacing(2),
  },

  divider: {
    margin: theme.spacing(2, 0)
  },
}));